import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { EVENT } from 'src/app/shared/constants/dali.constants';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import { TagEvent } from 'src/app/shared/models/dali-tags.model';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { CaptureService } from 'src/app/shared/services/capture/capture.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';
var PortalOperatorSummaryComponent = /** @class */ (function () {
    function PortalOperatorSummaryComponent(abrecuentasService, copyService, headerService, navigationService, parameterService, captureService, taggingService) {
        this.abrecuentasService = abrecuentasService;
        this.copyService = copyService;
        this.headerService = headerService;
        this.navigationService = navigationService;
        this.parameterService = parameterService;
        this.captureService = captureService;
        this.taggingService = taggingService;
        this.generalState = '';
        this.detailsText = '';
        this.currentStep = 0;
        this.anacreResponse = '';
        this.documentsUploaded = false;
        this.creditGrayZone = true;
        this.headerService.show(false, true, true);
    }
    PortalOperatorSummaryComponent.prototype.ngOnInit = function () {
        console.log('this.copyService.copies.portal_operator_summary');
        console.log(this.copyService.copies.portal_operator_summary);
        this.listsInitialization();
    };
    PortalOperatorSummaryComponent.prototype.next = function (code) {
        var _this = this;
        /* istanbul ignore else */
        if (code === 202) {
            this.taggEvent('2');
            this.captureService.documentarySufficiency(this.solicitationInfo.prospects[0].economic_activity, this.solicitationInfo.solicitation_type).then(function (res) {
                if (res.code === '200') {
                    var list = res.data;
                    list = list.filter(function (doc) { return doc.required_ind; }).map(function (doc) { return (tslib_1.__assign({}, doc, { isFileSizeCorrect: true, isFileTypeCorrect: true })); });
                    _this.abrecuentasService.setDocumentarySufficiencyList(list);
                    _this.navigationService.nextStep(code.toString());
                }
            });
        }
        else if (code === 200) {
            this.taggEvent('3');
            this.navigationService.nextStep(code.toString());
        }
        else if (code === 201) {
            this.navigationService.nextStep(code.toString());
        }
    };
    PortalOperatorSummaryComponent.prototype.listsInitialization = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.stepsList = this.parameterService.getSetting(OpEnum.PORTAL_OPERATOR_SUMMARY).stepsList;
                this.stateList = this.parameterService.getSetting(OpEnum.PORTAL_OPERATOR_SUMMARY).stateList;
                this.productsOrder = this.parameterService.getSetting(OpEnum.PORTAL_OPERATOR_SUMMARY).productsOrder;
                this.productsName = this.parameterService.getSetting(OpEnum.PORTAL_OPERATOR_SUMMARY).productsName;
                this.subproductsName = this.parameterService.getSetting(OpEnum.PORTAL_OPERATOR_SUMMARY).subproductsName;
                this.setInitialInfo();
                return [2 /*return*/];
            });
        });
    };
    PortalOperatorSummaryComponent.prototype.setInitialInfo = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                this.documentsUploaded = this.abrecuentasService.getDocumentsUploaded();
                if (this.documentsUploaded) {
                    setTimeout(function () {
                        _this.taggEvent('4', _this.copyService.copies.portal_operator_summary.documents_succesfull);
                    }, 500);
                }
                this.abrecuentasService.setDocumentsUploaded(false);
                this.solicitationInfo = this.abrecuentasService.getRequestModel();
                this.solicitationInfo = tslib_1.__assign({}, this.solicitationInfo, { dates: [] });
                console.log('this.solicitationInfo');
                console.log(this.solicitationInfo);
                this.setPhasesDates();
                this.setProductState();
                this.setDetailsText();
                this.getRejectedDocuments();
                return [2 /*return*/];
            });
        });
    };
    PortalOperatorSummaryComponent.prototype.setProductState = function () {
        var status = this.solicitationInfo.solicitation_status;
        var phase = this.solicitationInfo.solicitation_phase;
        console.log(this.anacreResponse);
        if ((phase === '11' && status === '10') ||
            (phase === '04' && (this.anacreResponse === 'NEGADO' || this.anacreResponse === 'DEVUELTO'))) {
            this.generalState = 'Rechazado';
        }
        else if (phase === '10' || ((phase === '04' || phase === '09') && this.anacreResponse === 'APROBADO')) {
            this.generalState = 'Aprobado';
        }
        else {
            this.generalState = 'En proceso';
        }
    };
    PortalOperatorSummaryComponent.prototype.setDetailsText = function () {
        if (this.generalState === 'Aprobado') {
            this.detailsText = this.solicitationInfo.dates[3] ?
                this.copyService.copies.portal_operator_summary.details_description_9
                : this.copyService.copies.portal_operator_summary.details_description_8;
        }
        else if (this.generalState === 'En proceso') {
            this.detailsText =
                this.solicitationInfo.dates[2] ? this.copyService.copies.portal_operator_summary.details_description_6
                    : this.solicitationInfo.dates[1] ? this.copyService.copies.portal_operator_summary.details_description_5
                        : this.copyService.copies.portal_operator_summary.details_description_1;
        }
        else {
            this.detailsText =
                this.solicitationInfo.dates[2] ? (!this.creditGrayZone ?
                    this.copyService.copies.portal_operator_summary.details_description_10
                    : this.copyService.copies.portal_operator_summary.details_description_7)
                    : this.solicitationInfo.dates[1] ? this.copyService.copies.portal_operator_summary.details_description_4
                        : this.copyService.copies.portal_operator_summary.details_description_3;
        }
        if (!this.solicitationInfo.products) {
            this.solicitationInfo.products = [];
        }
        this.setProductOrder();
        if (this.solicitationInfo.products.length <= 1) {
            return;
        }
        switch (this.detailsText) {
            case this.copyService.copies.portal_operator_summary.details_description_6:
                this.detailsText = this.copyService.copies.portal_operator_summary.details_description_6_multiproduct;
                break;
            case this.copyService.copies.portal_operator_summary.details_description_8:
                this.detailsText = this.copyService.copies.portal_operator_summary.details_description_8_multiproduct;
                break;
            case this.copyService.copies.portal_operator_summary.details_description_9:
                this.detailsText = this.copyService.copies.portal_operator_summary.details_description_9_multiproduct;
                break;
        }
    };
    PortalOperatorSummaryComponent.prototype.setPhasesDates = function () {
        var _this = this;
        var solicitationPhase = this.solicitationInfo.solicitation_phase;
        if (this.solicitationInfo.solicitation_status_history && this.solicitationInfo.solicitation_date_history) {
            this.solicitationInfo.solicitation_status_history.split(',').forEach(function (historyElement, index) {
                var solicitationPhaseElement = historyElement.split('-')[0];
                var solicitationStatus = historyElement.split('-')[1];
                var assignedDate = _this.solicitationInfo.solicitation_date_history.split(',')[index];
                switch (solicitationPhaseElement) {
                    case '02':
                        _this.solicitationInfo.dates = [];
                        _this.solicitationInfo.dates[0] = assignedDate;
                        _this.creditGrayZone = true;
                        break;
                    case '03':
                        switch (solicitationStatus) {
                            case '06':
                                _this.solicitationInfo.dates[0] = assignedDate;
                                break;
                            case '07':
                                _this.solicitationInfo.dates[1] = assignedDate;
                                break;
                            case '08':
                                _this.solicitationInfo.dates[1] = assignedDate;
                                break;
                        }
                        _this.creditGrayZone = true;
                        break;
                    case '04':
                        if (solicitationStatus === '05' || solicitationStatus === '09') {
                            _this.solicitationInfo.dates[2] = assignedDate;
                            _this.getAnacreResponse();
                        }
                        _this.creditGrayZone = true;
                        break;
                    case '07':
                        _this.creditGrayZone = false;
                        break;
                    case '08':
                        _this.creditGrayZone = false;
                        break;
                    case '09':
                        _this.creditGrayZone = false;
                        break;
                    case '10':
                        /* istanbul ignore next */
                        if (solicitationStatus === '10') {
                            _this.solicitationInfo.dates[3] = assignedDate;
                        }
                        break;
                    case '11':
                        /* istanbul ignore next */
                        if (solicitationStatus === '10') {
                            _this.solicitationInfo.dates[2] = assignedDate;
                        }
                        break;
                }
            });
        }
        if (this.solicitationInfo.solicitation_phase === '02') {
            this.solicitationInfo.dates[0] = '';
        }
        this.currentStep =
            !this.creditGrayZone ? (solicitationPhase === '07' || solicitationPhase === '08' || solicitationPhase === '09') ? -1
                : solicitationPhase === '11' ? 2 : 3
                : this.solicitationInfo.dates[3] ? 3
                    : this.solicitationInfo.dates[2] ? 2
                        : this.solicitationInfo.dates[1] ? 1 : 0;
        if (!this.creditGrayZone) {
            this.productsOrder = this.productsOrder.concat(this.parameterService.getSetting(OpEnum.PORTAL_OPERATOR_SUMMARY).productsOrderPasive);
        }
        this.creationDate = this.solicitationInfo.solicitation_date_history ?
            this.solicitationInfo.solicitation_date_history.split(',')[0] : new Date().toISOString();
    };
    PortalOperatorSummaryComponent.prototype.setProductOrder = function () {
        var e_1, _a, e_2, _b;
        this.temporalProducts = [];
        try {
            for (var _c = tslib_1.__values(this.productsOrder), _d = _c.next(); !_d.done; _d = _c.next()) {
                var order = _d.value;
                try {
                    for (var _e = (e_2 = void 0, tslib_1.__values(this.solicitationInfo.products)), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var product = _f.value;
                        if (product.product_type === order) {
                            this.temporalProducts.push(product);
                        }
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
        this.solicitationInfo.products = this.temporalProducts;
    };
    PortalOperatorSummaryComponent.prototype.getRejectedDocuments = function () {
        var _this = this;
        this.rejectedDocuments = [];
        if (typeof this.solicitationInfo.credit_analisys === 'undefined') {
            return;
        }
        var rejectedDocumentsText = this.solicitationInfo.credit_analisys
            .find(function (element) { return element.key === 'DOCUMENTOS'; });
        if (!rejectedDocumentsText) {
            return;
        }
        var rejectedDocumentsParts = rejectedDocumentsText.name.split(' \n');
        var documentsElement = {
            name: '',
            reasons: '',
        };
        rejectedDocumentsParts.forEach(function (element, index) {
            if ((element.includes(_this.copyService.copies.portal_operator_summary.rejected_document_name_util)
                && index !== 0) || element === '') {
                _this.rejectedDocuments.push(documentsElement);
                documentsElement = {
                    name: '',
                    reasons: '',
                };
            }
            if (element.includes(_this.copyService.copies.portal_operator_summary.rejected_document_name_util)) {
                documentsElement.name = element.split(_this.copyService.copies.portal_operator_summary.rejected_document_name_util)[1]
                    .split(_this.copyService.copies.portal_operator_summary.rejected_document_name_util_2)[0];
            }
            if (!element.includes(_this.copyService.copies.portal_operator_summary.rejected_document_name_util_1)) {
                return;
            }
            if (!documentsElement.reasons) {
                documentsElement.reasons = element.split(_this.copyService.copies.portal_operator_summary.rejected_document_name_util_1)[1]
                    .split(':')[0];
            }
            else {
                documentsElement.reasons += ', '
                    + element.split(_this.copyService.copies.portal_operator_summary.rejected_document_name_util_1)[1]
                        .split(':')[0];
            }
        });
    };
    PortalOperatorSummaryComponent.prototype.getAnacreResponse = function () {
        if (typeof this.solicitationInfo.credit_analisys === 'undefined') {
            return;
        }
        var creditResponse = this.solicitationInfo.credit_analisys
            .find(function (element) { return element.key === 'RESPUESTA'; });
        if (!creditResponse) {
            return;
        }
        this.anacreResponse = creditResponse.name;
    };
    PortalOperatorSummaryComponent.prototype.formatDate = function (date) {
        var mydate = new Date(date);
        var day = mydate.getDate().toString();
        var month = (mydate.getMonth() + 1).toString();
        var year = mydate.getFullYear();
        if (+day < 10) {
            day = "0" + day;
        }
        if (+month < 10) {
            month = "0" + month;
        }
        return day + "/" + month + "/" + year;
        // return date ? date.split('T')[0].replace(new RegExp('-', 'g'), '/') : '';
    };
    PortalOperatorSummaryComponent.prototype.formatNumberAsCurrency = function (number) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    };
    PortalOperatorSummaryComponent.prototype.taggEvent = function (tag_number, description) {
        var tagPageName = this.navigationService.getCurrentStep().tag_name;
        try {
            var changes = this.taggingService.createTagChanges(tagPageName, tag_number);
            if (EVENT[tagPageName + "E" + tag_number + "setData"][tagPageName + "E" + tag_number + "transactionProductDetails"]) {
                changes.push({
                    path: EVENT[tagPageName + "E" + tag_number + "setData"][tagPageName + "E" + tag_number + "transactionProductDetails"].path,
                    value: this.navigationService.camelize(description ? description : ''),
                });
            }
            var event_1 = {
                category: {
                    module: EVENT.customCategory.module.body,
                    type: EVENT.customCategory.type.button,
                    position: EVENT.customCategory.position.bottom,
                },
                action: EVENT.customAction.click,
                label: EVENT[tagPageName + "E" + tag_number + "customLabel"],
            };
            switch (tag_number) {
                case '2':
                    event_1.category = {
                        module: EVENT.customCategory.module.body,
                        type: EVENT.customCategory.type.button,
                        position: EVENT.customCategory.position.center,
                    };
                    event_1.action = EVENT.customAction.click;
                    break;
                case '3':
                    event_1.category = {
                        module: EVENT.customCategory.module.body,
                        type: EVENT.customCategory.type.link,
                        position: EVENT.customCategory.position.center,
                    };
                    event_1.action = EVENT.customAction.click;
                    break;
                case '4':
                    event_1.category = {
                        module: EVENT.customCategory.module.body,
                        type: EVENT.customCategory.type.warning,
                        position: EVENT.customCategory.position.top,
                    };
                    event_1.action = EVENT.customAction.show;
                    break;
            }
            this.taggingService.pageTagEvent(event_1, changes);
        }
        catch (error) {
            console.log("Error enn " + error);
        }
    };
    return PortalOperatorSummaryComponent;
}());
export { PortalOperatorSummaryComponent };
